import styled from 'styled-components';

export const ShareFullScreenButtonWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 999999;
`;

export const SocialListWrapper = styled.div`
  background: #333;
  position: absolute;
  padding: 17px;
  width: 400px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  max-height: fit-content;
  margin: auto;
  border-radius: 8px;
`

export const SocialListHeaderWrapper = styled.div `
  padding: 6px;
  margin-bottom: 19px;
  font-weight: 500;
  font-size: 16px;
`

export const SocialListAction = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 50px;
`

export const SocialListContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;


`
